module.exports = __webpack_public_path__ + "static/ecom-dashboards-light-plp-7f2ba972c8ee4c44ebfea65c8eca9a17.png";